import Times from '~/bootcamp/Activities/components/Times'
import { range } from '~/utils/helpers'

export default function ExpressionInternational({
  multiplier,
  multiplicand,
}: {
  multiplier: string
  multiplicand: string
}): React.ReactElement {
  const multiplierGridStyle = {
    display: 'grid',
    gridTemplateColumns: `repeat(${multiplier.length}, minmax(0, 1fr))`,
  }

  const multiplicandGridStyle = {
    display: 'grid',
    gridTemplateColumns: `repeat(${multiplicand.length}, minmax(0, 1fr))`,
  }

  return (
    <span className="w-full self-end flex flex-col text-center text-md sm:text-lg font-semibold text-purple">
      <div className="self-end" style={multiplierGridStyle}>
        {range(multiplier.length).map((index) => (
          <span className="w-8 sm:w-10" key={`multiplier-expression-international-${index}`}>
            {multiplier[index]}
          </span>
        ))}
      </div>
      <div className="w-full flex justify-between items-center">
        <Times />
        <div style={multiplicandGridStyle}>
          {range(multiplicand.length).map((index) => (
            <span className="w-8 sm:w-10" key={`multiplicand-expression-international-${index}`}>
              {multiplicand[index]}
            </span>
          ))}
        </div>
      </div>
    </span>
  )
}
